import {
  ActionStatusTypes,
  ICreateBadgesResponse,
  IIssuancePaginatedResponseModel,
} from "../../types/interfaces";

export enum BadgesActionsTypes {
  SELECT_BADGE_ID = "badges/select_id",
  GET_BADGES_DATA = "badges/get_data",
  GET_BADGES_DATA_SUCCESS = "badges/get_data_success",
  GET_BADGES_DATA_FAILED = "badges/get_data_failed",
  DELETE_BADGE = "badges/delete_badge",
  DELETE_BADGE_SUCCESS = "badges/delete_badge_success",
  DELETE_BADGE_FAILED = "badges/delete_badge_failed",
  CREATE_BADGES = "badges/create_badges",
  CREATE_BADGES_SUCCESS = "badges/create_badges_success",
  CREATE_BADGES_FAILED = "badges/create_badges_failed",
  CLEAN_CREATE_BADGES_RESPONSE = "badges/clean_create_badges_response",
}

export interface ISelectBadgeId {
  type: BadgesActionsTypes.SELECT_BADGE_ID;
  payload: {
    badgeId?: string;
  };
}

export interface IGetBadgesData {
  type: BadgesActionsTypes.GET_BADGES_DATA;
  payload: {
    param?: string;
    searchValue?: string;
    page?: number;
    size?: number;
  };
}

export interface IGetBadgesDataSuccess {
  type: BadgesActionsTypes.GET_BADGES_DATA_SUCCESS;
  payload: IIssuancePaginatedResponseModel;
}

export interface IGetBadgesDataFailed {
  type: BadgesActionsTypes.GET_BADGES_DATA_FAILED;
  payload: {
    error: string;
  };
}

export interface IDeleteBadge {
  type: BadgesActionsTypes.DELETE_BADGE;
  payload: {
    badgeId: string;
  };
}

export interface IDeleteBadgeSuccess {
  type: BadgesActionsTypes.DELETE_BADGE_SUCCESS;
}

export interface IDeleteBadgeFailed {
  type: BadgesActionsTypes.DELETE_BADGE_FAILED;
}

export interface ICreateBadges {
  type: BadgesActionsTypes.CREATE_BADGES;
  payload: {
    campaignName: string;
    file: File;
  };
}

export interface ICreateBadgesSuccess {
  type: BadgesActionsTypes.CREATE_BADGES_SUCCESS;
  payload: {
    response: ICreateBadgesResponse;
  };
}

export interface ICreateBadgesFailed {
  type: BadgesActionsTypes.CREATE_BADGES_FAILED;
}

export interface ICleanCreateBadgesResponse {
  type: BadgesActionsTypes.CLEAN_CREATE_BADGES_RESPONSE;
}

export type BadgesActions =
  | ISelectBadgeId
  | IGetBadgesData
  | IGetBadgesDataSuccess
  | IGetBadgesDataFailed
  | IDeleteBadge
  | IDeleteBadgeSuccess
  | IDeleteBadgeFailed
  | ICreateBadges
  | ICreateBadgesSuccess
  | ICreateBadgesFailed
  | ICleanCreateBadgesResponse;
export interface IBadgesListState {
  selectedBadgeId?: string;
  badgesData?: IIssuancePaginatedResponseModel;
  loadBadgesDataStatus?: ActionStatusTypes;
  delBadgesStatus?: ActionStatusTypes;
  deleteBadgeStatus?: ActionStatusTypes;
  createBadgesStatus?: ActionStatusTypes;
  createBadgesResponse?: ICreateBadgesResponse;
  error: string;
}
